import type { Meta, StoryObj } from "@storybook/react";

import { IllustrationSize } from "@/constants/UI";
import type { EmptyListBaseCardProps } from "@/ui/layout/list/EmptyListBaseCard";
import EmptyListBaseCard from "@/ui/layout/list/EmptyListBaseCard";
import { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";

const StoryMeta: Meta<EmptyListBaseCardProps> = {
  title: "Layout/Empty List Card",
  component: EmptyListBaseCard,
  argTypes: {
    description: { control: "text" },
    iconHeight: { control: "number" },
    iconName: { control: "select", options: Object.values(IllustrationName) },
    iconWidth: { control: "number" },
    testID: { control: "text" },
    title: { control: "text" },
  },
  args: {
    description: "Once data has been logged, you'll be able to see it here",
    iconHeight: IllustrationSize.Weight,
    iconName: IllustrationName.Exclamation,
    iconWidth: IllustrationSize.Weight,
    title: "No data has been logged",
  },
};

type Story = StoryObj<EmptyListBaseCardProps>;

export const Primary: Story = {};
export default StoryMeta;
